export interface TrackBackground {
  min: number
  max: number
  values: number[]
  colors: string[]
}

export function getTrackBackground({
  values,
  colors,
  min,
  max,
}: TrackBackground) {
  if (colors.length === 1)  return colors[0]

  // sort values ascending
  const progress = values
    .slice(0)
    .sort((a, b) => a - b)
    .map(value => ((value - min) / (max - min)) * 100)
  const middle = progress.reduce(
    (acc, point, index) => `${acc}, ${colors[index]} ${point}%, ${colors[index + 1]} ${point}%`,
    ''
  )
  return `linear-gradient(to right, ${colors[0]} 0%${middle}, ${
    colors[colors.length - 1]
  } 100%)`
}
